<div class="table-row-actions">
  @for (
    action of itemActions() | onlyVisibleTableItemActions: model();
    track action
  ) {
    <app-table-item-action
      [action]="action"
      [model]="model()" />
  }
</div>
